module.exports = __webpack_public_path__ + "img/icon_followers.c3c68033.png";